import axios from 'axios';

const publicBillingAxios = axios.create({ baseURL: process.env.REACT_APP_BILLING_BASE_URL });

const downloadMSA = async file => {
  try {
    const response = await publicBillingAxios.post(
      '/selfserve/download-msa',
      { url: file },
      {
        responseType: 'arraybuffer',
      },
    );
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `UPShow Order Form & MSA ${process.env.REACT_APP_MSA_TEMPLATE_VERSION}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (e) {
    e.name = 'msa_error';
    throw e;
  }
};

export default downloadMSA;
